import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";

const TruncatableText = ({
  children,
  maxWidth = 100,
  style = {},
  ...props
}) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children, maxWidth, style]);

  const textStyle = {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth,
    verticalAlign: "bottom",
    ...style
  };

  const content = (
    <span ref={textRef} style={textStyle} {...props}>
      {children}
    </span>
  );

  return isTruncated ? <Tooltip title={children}>{content}</Tooltip> : content;
};

export default TruncatableText;
